export default function getStatusColor (status) {
	return status === 'active' ? '#21df21' : '#dfac21';
};